import React from 'react';

import { Button, Drawer, Select, Spin } from 'antd';

import { useProductChangeHistoryDetails } from 'v2/hooks/useProductChangeHistoryDetails';
import type { ChangeHistoryContentItem } from 'v2/interfaces/productChangeHistory';

import { Icon } from '@eduzz/ui-antd-theme';

import ChangesList from './ChangesList';
import { FieldsNameBR } from './constants';
import type { ChangeLogHistory } from './constants';
import { Title } from './Title';

type ChangeHistoryDetailsProps = {
  data: ChangeHistoryContentItem;
  isOpen: boolean;
  onClose: () => void;
};

function ChangeHistoryDetails({ data, isOpen, onClose }: ChangeHistoryDetailsProps) {
  const [filteredField, setFilteredField] = React.useState('0');

  const changeHistoryDetailsQuery = useProductChangeHistoryDetails({
    productId: data.productId,
    historyId: data.historyId
  });

  const handleChange = (value: string) => {
    setFilteredField(value);
  };

  const getFilterActionOptions = (changeLog: ChangeLogHistory[]) => {
    const fields = changeLog.map(history => ({
      label: FieldsNameBR[history.field as keyof typeof FieldsNameBR],
      value: history.field
    }));

    return [{ label: 'Busque por campo', value: '0' }, ...fields];
  };

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      width='100vw'
      title={<Title content={data} />}
      closeIcon={<Button type='text' shape='circle' aria-label='Voltar' icon={<Icon.ChevronLeft size={16} />} />}
      footer={
        <div className='flex justify-end'>
          <Button type='text' onClick={onClose}>
            Fechar
          </Button>
        </div>
      }
    >
      <div className='flex flex-col items-center gap-4'>
        {changeHistoryDetailsQuery.isLoading && <Spin />}

        {changeHistoryDetailsQuery.data && (
          <>
            <Select
              size='small'
              className='w-full md:w-2/5'
              value={filteredField}
              onChange={handleChange}
              options={getFilterActionOptions(changeHistoryDetailsQuery.data)}
            />

            <ChangesList changelog={changeHistoryDetailsQuery.data} filteredField={filteredField} />
          </>
        )}
      </div>
    </Drawer>
  );
}

export default ChangeHistoryDetails;
